import styled from "styled-components";
import { theme } from "../../../../theme";

export const StyledPricingCard = styled.div<{ active?: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: 24px;
  margin-bottom: 24px;
  border: 1px solid ${theme.textColor.primaryGray};
  width: 380px;
  height: 500px;
  background-color: ${({ active }) =>
    active
      ? theme.backgroundColor.primaryBlack
      : theme.backgroundColor.primaryWhite};
  -webkit-box-shadow: 0px 0px 10px 0 rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 0px 10px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 10px 0 rgba(0, 0, 0, 0.1);
  position: relative;
  color: ${({ active }) =>
    active ? theme.textColor.primaryWhite : theme.textColor.primaryBlack};
  @media (max-width: 1100px) {
    width: auto;
    margin-bottom: 0;
    height: auto;
  }
`;
export const StyledPricingHeader = styled.div`
  h2 {
    font-weight: 500;
    margin: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
  }
  span {
    display: block;
    font-size: 14px;
    margin: 0 !important;
    color: ${theme.textColor.tertiaryGray};
  }
`;
export const StyledPricingBody = styled.div`
  padding: 24px 0;
`;
export const StyledAmount = styled.h2<{ active?: boolean }>`
  font-size: 36px;
  font-weight: 300;
  margin: 0;
  span {
    font-size: 18px;
    font-weight: 200;
    margin-left: 8px;
  }
  span:first-child {
    text-decoration: line-through;
    color: ${({ active }) =>
      active ? theme.textColor.secondaryGray : theme.textColor.quaternaryGray};
  }
`;

export const StyledPricingAction = styled.div`
  width: 100%;
  margin-top: auto;
  button {
    width: 100%;
  }
`;

export const StyledFeatureList = styled.ul`
  list-style: none;
  padding: 0;
  li {
    margin: 16px 0;
    svg {
      margin-right: 8px;
      vertical-align: middle;
    }
    span {
      vertical-align: middle;
    }
  }
`;
